import React from "react";
import "./index.less";
import { Image } from "antd";
import { useNavigate } from "react-router-dom";
import { findFirstLevelCategoryKeys } from "@/hooks/useMenusSelect";
interface ResourceOverviewCardProps {
  data: any;
  elementId: string
}

const prefix = "resource-overview-card";
const ResourceOverviewCard: React.FC<ResourceOverviewCardProps> = (props) => {
  const { data,elementId } = props;
  const navigate = useNavigate();
  const goDetail = () => {
    const children= findFirstLevelCategoryKeys([data]);
    console.log(children.selectedKeys);
    const resourceId = children.selectedKeys?.[0];
    navigate('/freedownload?resourceId='+resourceId);
  };
  return (
    <div className={`${prefix}`} id={elementId}>
      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header-img`}>
         {
          data?.meta?.image && <Image src={data.meta.image} alt="" />
         } 
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <div className={`${prefix}-content-title one-line-ellipsis`}>
            {data?.title}
        </div>
        <div className={`${prefix}-content-desc`}>
            {data?.meta?.description}
        </div>
        <div className={`${prefix}-content-footer`}>
            <span onClick={goDetail}>查看下载资源</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ResourceOverviewCard);
